module.exports = __webpack_public_path__ + "img/rings-info.cd53466c.png";